<script setup lang="ts">
import { useField } from 'vee-validate';
import QuestionCheckBox from '@/application/shared/infrastructure/components/questionTypes/QuestionCheckBox.vue';

const termsOptions : Array<{text: string, value: string}> = [{
  text: 'I agree to the Terms and Conditions.',
  value: 'terms'
}, {
  text: 'I agree to the Consent of Verification.',
  value: 'consent'
}];

const props = defineProps<{
  value: {agree_consent: boolean, agree_terms_and_conditions: boolean }
}>();

const {
  value: terms,
  meta: termsMeta,
  errorMessage: termsError,
} = useField('terms', { required: true }, { initialValue: props.value.agree_terms_and_conditions ? [termsOptions[0].value] : [''] });

const {
  value: consent,
  meta: consentMeta,
  errorMessage: consentError,
} = useField('consent', { required: true }, { initialValue: props.value.agree_consent ? [termsOptions[1].value] : [''] });

interface EmitInterface {
  (event: 'update:value', value: Array<string>): void
}

const emits = defineEmits<EmitInterface>();

const emitChange = (): void => {
  emits('update:value', [...terms.value, ...consent.value].filter(option => !!option));
};

defineExpose({
  acceptAll: async () => {
    terms.value = [termsOptions[0].value];
    consent.value = [termsOptions[1].value];
    emitChange();
  }
});

</script>
<template>
  <QuestionCheckBox v-model="terms" name="terms" @change="emitChange" :options="[termsOptions[0]]" :class="{ error: !termsMeta.valid && termsMeta.validated }" />
  <span class="error">{{ termsError }}</span>
  <QuestionCheckBox v-model="consent" name="consent" @change="emitChange" :options="[termsOptions[1]]" :class="{ error: !consentMeta.valid && consentMeta.validated }" />
  <span class="error">{{ consentError }}</span>
</template>
